import type { MedplumClient } from '@medplum/core';
import { SERVICE_REQUEST_EOC_EXT } from '@unify/fhir-model/constants';

/** Practice Organization id from the ServiceRequest paired with this episode (performer[0]). */
export async function resolveOrganizationIdFromEpisode(
  medplum: MedplumClient,
  patientId: string,
  episodeId: string,
): Promise<string> {
  const srs = await medplum.searchResources('ServiceRequest', {
    subject: `Patient/${patientId}`,
    _count: '50',
  });
  const eocRef = `EpisodeOfCare/${episodeId}`;
  for (const sr of srs) {
    const linked = sr.extension?.find((e) => e.url === SERVICE_REQUEST_EOC_EXT)?.valueReference
      ?.reference;
    if (linked !== eocRef) continue;
    const orgId = sr.performer?.[0]?.reference?.replace(/^Organization\//, '');
    if (orgId) return orgId;
  }
  throw new Error('Could not resolve practice for this episode (ServiceRequest.performer is missing).');
}
